/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterColor_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuColorSelect_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterColor_itemSearch";
};
export type SbSharedRefineMenuFilterColor_itemSearch$data = SbSharedRefineMenuFilterColor_itemSearch;
export type SbSharedRefineMenuFilterColor_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterColor_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterColor_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterColor_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuColorSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '1982be8a0d269a8fc9592c9e440e3002';
export default node;
